import React, {useEffect} from "react";
import Hero from "../Components/Hero";
import Clients from "../Components/Clients";
import FeatureSection from "../Components/FeaturesSection";
import StatsSection from "../Components/Stats";
import ProblemSolutionSection from "../Components/ProblemSolutionSection";
import WhatsappAutomationSteps from "../Components/WhatsappAutomationSteps";
import StartScalingConversationsSection from "../Components/StartScalingConversationsSection";
import IndustriesSection from "../Components/IndustriesSection";
import Testimonials from "../Components/Testimonials";
import PricingPlans from "../Components/PricingPlans";
import Faqs from "../Components/Faqs";
import Cta from "../Components/Cta";
import IntegrationLogos from "../Components/IntegrationLogos";
import SchemaMarkup from '../Components/SchemaMarkup'
import OrganizationSchema from "../Schema/OrganizationSchema";
import WebSiteSchema from "../Schema/WebsiteSchema";
import SoftwareApplicationSchema from "../Schema/SoftwareApplicationSchema";
import OtherBlogs from "../Components/OtherBlogs";

const Home=()=>{

    useEffect(() => {
    document.title =
      "ONBBITS | WhatsApp Business API & Automation Platform";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Automate customer conversations with ONBBITS. Official WhatsApp Business API, chatbots, broadcasts, team inbox and analytics to grow your business."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "ONBBITS | WhatsApp Business API & Automation Platform"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Automate customer conversations with ONBBITS. Official WhatsApp Business API, chatbots, broadcasts, team inbox and analytics to grow your business."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "ONBBITS | WhatsApp Business API & Automation Platform"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Automate customer conversations with ONBBITS. Official WhatsApp Business API, chatbots, broadcasts, team inbox and analytics to grow your business."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }
  }, [])

    return(
        <>
        <SchemaMarkup data={OrganizationSchema} />
<SchemaMarkup data={WebSiteSchema} />
<SchemaMarkup data={SoftwareApplicationSchema} />

        {/**HERO SECTION */}
        <Hero />

        {/**CLIENTS SECTION */}
        <Clients />

        {/**AN ENTIRE OPERATING SYSTEM FOR CONVERSATIONS */}
        <FeatureSection />

        {/**STATS SECTION */}
        <StatsSection />

        {/**PROBLEM SOLUTION SECTION */}
        <ProblemSolutionSection />

         {/**INTEGRATION LOGOS SECTION */}
        <IntegrationLogos />

        {/**STOP MANAGING CHAOS. START SCALING CONVERSATION SECTION */}
        <StartScalingConversationsSection />

        {/**AUTOMATE YOUR WHATSAPP SECTION */}
        <WhatsappAutomationSteps />

        {/**INDUSTRY CARDS SECTION */}
        <IndustriesSection />

        {/**TESTIMONIALS */}
        <Testimonials />

        {/**PRICING PLANS SECTION */}
        <PricingPlans />

        {/**FAQS SECTION */}
        <Faqs />

        {/**BLOGS SECTION */}
        <OtherBlogs />

        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default Home;